import { LanguageBackendType } from "../shared/components/language/types";
import { FlexibleInvoicingModel } from "./options/flexible-invoicing/types";
import { LegalForm } from "../home/types";

export type DecentralizedInvoicingAddress =
  | "COMPANY_ADDRESS"
  | "PRIVATE_ADDRESS";

export enum YesNo {
  YES = "yes",
  NO = "no",
}

export interface GeneralCompanyInformationModel {
  limit: string;
  expectedSpendingPerMonth?: string;
  correspondenceLanguage: LanguageBackendType;
  bankCode: string;
  bankName: string;
  iban: string;
  hasCompanyOnCard: YesNo;
  flexibleInvoicing: FlexibleInvoicingModel;
  legalForm: LegalForm;
  hasDecentralizedInvoicing: boolean;
  decentralizedInvoicingAddress: DecentralizedInvoicingAddress;
}
